import { render, staticRenderFns } from "./EditPrimaryFarm.vue?vue&type=template&id=6cc6109a"
import script from "./EditPrimaryFarm.vue?vue&type=script&lang=js"
export * from "./EditPrimaryFarm.vue?vue&type=script&lang=js"
import style0 from "./EditPrimaryFarm.vue?vue&type=style&index=0&id=6cc6109a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports